export default "/_next/static/assets/smart-banner-logo_9846771956b211c43dd09ed037fb5da2.jpg";